import { render, staticRenderFns } from "./AccordionSectionResource.vue?vue&type=template&id=2b4edc90&scoped=true"
import script from "./AccordionSectionResource.vue?vue&type=script&lang=js"
export * from "./AccordionSectionResource.vue?vue&type=script&lang=js"
import style0 from "./AccordionSectionResource.vue?vue&type=style&index=0&id=2b4edc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4edc90",
  null
  
)

export default component.exports